import { useMemo } from 'react';
import { Skeleton } from '@comeon/ui';
import gridTemplates from './grids';
import styled from 'styled-components';

const SkeletonContainer = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 25px;
	overflow: hidden;
	max-width: 100%;
	margin-left: 12px;
`;

const ExploreSkeleton = () => {
	const { GridComponent } = gridTemplates[0];
	const GameCards = useMemo(() => {
		const cards = [];

		for (let i = 0; i < window.innerWidth / 182; i += 1) {
			cards.push(<Skeleton borderRadius="12px" />);
		}

		return cards;
	}, []);
	return (
		<SkeletonContainer>
			<div>
				<Skeleton width={210} height={30} margin="0 0 10px 0" />
				<GridComponent itemDisplayType="m" categoryType="simple" GameCards={GameCards} />
			</div>
			<div>
				<Skeleton width={210} height={30} margin="0 0 10px 0" />
				<GridComponent itemDisplayType="m" categoryType="simple" GameCards={GameCards} />
			</div>
			<div>
				<Skeleton width={210} height={30} margin="0 0 10px 0" />
				<GridComponent itemDisplayType="m" categoryType="simple" GameCards={GameCards} />
			</div>
		</SkeletonContainer>
	);
};

export default ExploreSkeleton;
